import { GhostPracticeCode } from '@models/ghost-practice';
import { SolunoActivityCode } from '@models/soluno';
import { MatterStatementOfAccount } from '@models/statementOfAccount';

export type NotApplicableType = 'N/A';

export const NotApplicableValue: NotApplicableType = 'N/A';
export interface SolunoItem {
	accountingItem: SolunoAccountingItem;
	statement: MatterStatementOfAccount;
}
export interface SolunoAccountingItem extends AccountingItem {
	activityCode: SolunoActivityCode;
	statementId: string;
	hst: boolean;
}

export interface GhostPracticeItem {
	accountingItem: GhostPracticeAccountingItem;
	statement: MatterStatementOfAccount;
}
export interface GhostPracticeAccountingItem extends AccountingItem {
	ghostPracticeCode: GhostPracticeCode;
	statementId: string;
	hst: boolean;
}

export interface AccountingItem {
	title: string;
	amount: number;
}
